import Ease from '@CS/utils/Easing';
import { Theme } from '@/theme/Theme';
import styled, { css } from 'styled-components';

const TRANSITION_DURATION = 500;
export const FADE_DURATION = TRANSITION_DURATION - 100;

type PopupOverlayAttributes = {
  opacity: number | string;
  $visible: boolean;
  $overlay: boolean;
};

export const PopupOverlay = styled.aside<PopupOverlayAttributes>(
  ({ $visible, $overlay, opacity }) => css`
    transition: background-color ${FADE_DURATION}ms;
    background-color: rgb(0 0 0 / 0);

    position: fixed;
    height: 100%;
    width: 100%;

    z-index: 2;
    padding: 0;

    margin: 0;
    inset: 0;

    ${$visible &&
    css`
      ${$overlay &&
      css`
        background-color: rgb(0 0 0 / ${opacity});
      `}

      > dialog {
        transition-timing-function: ${Ease.Out.Sine};
        transform: translate(-50%, -50%) scale(1);
        transition-delay: 0s;
        opacity: 1;
      }
    `}
  `
);

const OPACITY_DURATION = TRANSITION_DURATION * 0.5;

type PopupContainerAttributes = {
  width?: number | string;
  $fullScreen?: boolean;
  $landscape?: boolean;
};

export const PopupContainer = styled.dialog<PopupContainerAttributes>(
  ({ $fullScreen, $landscape, width }) => css`
    transition:
      transform ${FADE_DURATION}ms ${Ease.In.Sine},
      opacity ${OPACITY_DURATION}ms ${FADE_DURATION - OPACITY_DURATION}ms;

    transform: translate(-50%, -50%) scale(0.75);
    background-color: ${Theme.color.white};

    will-change: transform, opacity;
    backface-visibility: hidden;
    transform-origin: center;

    min-height: 37.85dvh;
    max-height: 77.25dvh;

    border-radius: 15px;
    position: absolute;

    min-width: 280px;
    max-width: 400px;

    overflow: auto;
    display: block;

    padding: 30px;
    border: none;

    opacity: 0;
    margin: 0;

    left: 50%;
    top: 50%;

    ${width &&
    css`
      width: ${width}%;
    `}

    ${$landscape &&
    css`
      max-height: 87.69dvh;
    `}

    ${$fullScreen &&
    css`
      max-height: 100dvh;
      border-radius: 0;

      height: 100dvh;
      width: 100vw;
    `}

    > svg {
      position: relative;
      margin-left: auto;

      margin-right: 0;
      cursor: pointer;

      display: block;
      z-index: 1;
    }
  `
);
